import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';
import {TabPanel} from "react-tabs";

export default class TicketRefundRequest extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <h3 className="mb0 mt40">티켓 환불 요청 API</h3>
                <div className="blog-post-meta">
                    <span className="s-post">티켓을 환불요청합니다. 이 API를 이용해 최대 5개의 티켓을 환불요청 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">POST</span>
                    </h3>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-request</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-request
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="5" className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>ticketNumbers</td>
                            <td>O</td>
                            <td>String</td>
                            <td>티켓번호 리스트</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>ticketNumber</td>
                            <td>String</td>
                            <td>티켓번호</td>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>Long</td>
                            <td>딜번호</td>
                        </tr>
                        <tr>
                            <td>cancelRequestStatusType</td>
                            <td>String</td>
                            <td>
                                "CANCEL_PROGRESS" : 환불진행중<br/>
                                "CANCEL_FAIL" : 환불실패<br/>
                                "CANCEL_COMPLETE" : 환불완료<br/>
                                "CANCEL_INVALID_REQUEST" : 유효하지 않은 티켓
                            </td>
                        </tr>
                        <tr>
                            <td>requestedAt</td>
                            <td>Date</td>
                            <td>환불요청일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>cancelCompletedAt</td>
                            <td>Date</td>
                            <td>환불완료일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "message": "SUCCESS",
            "data": {
                "2C9A62-15000000000587": {
                    "ticketNumber": "2C9A62-15000000000587",
                    "dealId": 6500124650,
                    "cancelRequestStatusType": "CANCEL_PROGRESS",
                    "requestedAt": "2017-11-07 13:34:22",
                    "cancelCompletedAt": null
                    "message": "환불진행중"
                }
            }
        }
                        `}
                    </pre>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketManagementAPI/TicketRefundRequest.jsx